module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-172052937eb37ee3a2bb66da6fd227bf.webp";